import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EdapModuleView from '../EdapModuleView';
import { Experiment } from '../Experiment';
import TrendingCard from './TrendingCard';
import Carousel from '../Carousel';
import TrendingModal from './TrendingModal';

import { FormattedMessage } from '../Intl';
import { messageKeys, getLabels } from './translations';
import { evaluateExperimentAndLog } from '@homeaway/abacus-client-utils';

import {
  handleEdapClick,
  triggerEdapEvent
} from '../../utils/edap';

import {
  TRENDING_DESTINATION_LINK_CLICK,
  TRENDING_CLICK_PREV,
  TRENDING_CLICK_NEXT,
  MODULE_VIEW_EVENT_OPTIONS
} from './events';

import './Trending.less';

const DEFAULT_STATE = {
  isOpen: false,
  locationQuery: '',
  url: {
    slpUrl: '',
    serpUrl: ''
  }};

class Trending extends Component {
  static propTypes = {
    tiles: PropTypes.arrayOf(PropTypes.object).isRequired
  }

  static defaultProps = {
    tiles: []
  }

  state = DEFAULT_STATE;

  // Arrow handlers
  handlePreviousClick() {
    triggerEdapEvent(TRENDING_CLICK_PREV);
  }

  handleNextClick() {
    triggerEdapEvent(TRENDING_CLICK_NEXT);
  }

  handleModuleViewed = () => {
    evaluateExperimentAndLog('HA_PTA_HP_AditionalInfoTrendingDestinations');
    evaluateExperimentAndLog('HA_PTA_HP_TrendingDestinationsTitles');
    evaluateExperimentAndLog('HA_HP_NewCarouselDatePicker_');
  }

  // Modal
  handleOpenModal = ({ lbsId, slpUrl, serpUrl, locationQuery }) => (evt) => {
    evt.preventDefault();
    triggerEdapEvent(TRENDING_DESTINATION_LINK_CLICK, { lbsUuid: lbsId });
    this.setState({ isOpen: true, url: { slpUrl, serpUrl }, locationQuery });
  }

  handleCloseModal = () => {
    this.setState({ ...DEFAULT_STATE });
  }

  render() {
    const {
      tiles
    } = this.props;

    const { isOpen, locationQuery, url } = this.state;

    return (
      tiles && tiles.length > 0 &&
        <section className="Content__section">
          <Experiment name={'HA_PTA_HP_TrendingDestinationsTitles'}>
            {valueTitle =>
              (
                <EdapModuleView eventOptions={MODULE_VIEW_EVENT_OPTIONS} onModuleViewed={this.handleModuleViewed} >
                  <FormattedMessage id={messageKeys}>
                    {(...messages) => (
                      <TrendingModal
                        isOpen={isOpen}
                        locationQuery={locationQuery}
                        url={url}
                        handleClose = {this.handleCloseModal}
                        labels = {getLabels(...messages)}
                      />
                    )}
                  </FormattedMessage>
                  <Experiment name={'HA_HP_NewCarouselDatePicker_'}>
                    {value =>
                      (
                        <FormattedMessage id={['trending.title', 'trending.modal.title1', 'trending.modal.subtitle1', 'trending.modal.title2', 'trending.modal.subtitle2', 'trending.modal.title3', 'trending.modal.subtitle3']}>
                          {(defaultTitle, trendingTitle1, trendingSubheading1, trendingTitle2, trendingSubheading2, trendingTitle3, trendingSubheading3) => {
                            const titles = { defaultTitle, trendingTitle1, trendingTitle2, trendingTitle3 };
                            const subheadings = { trendingSubheading0: '', trendingSubheading1, trendingSubheading2, trendingSubheading3 };
                            const title = valueTitle === 0 || valueTitle === null ? titles.defaultTitle : titles[`trendingTitle${valueTitle}`];
                            return (
                              <Carousel
                                title={title}
                                subheading={subheadings[`trendingSubheading${valueTitle}`]}
                                onPreviousClick={this.handlePreviousClick}
                                onNextClick={this.handleNextClick}
                              >
                                {tiles.map(item => (
                                  <TrendingCard key={item.lbsId} onClick={value ? this.handleOpenModal(item) : handleEdapClick(TRENDING_DESTINATION_LINK_CLICK, { lbsUuid: item.lbsId })} {...item} />
                                ))}
                              </Carousel>
                            );
                          }}
                        </FormattedMessage>
                      )
                    }
                  </Experiment>
                </EdapModuleView>
              )
            }
          </Experiment>
        </section>
    );
  }
}

export default Trending;



// WEBPACK FOOTER //
// ./src/universal/components/Trending/Trending.js